import { AbstractControl, ValidationErrors } from '@angular/forms';

/**
 * Custom validator to prevent script injection
 */
export function noScriptValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) return null;

  const scriptPattern =
    /<script[^>]*>.*?<\/script>|javascript:|on\w+\s*=|<\s*\/?\s*(script|iframe|object|embed|form|input|meta|link)/gi;
  const hasScript = scriptPattern.test(control.value);

  return hasScript ? { containsScript: true } : null;
}
